import React from "react";
import loadable from "@loadable/component";

const Video = loadable(() => import("./Video"));

const VideoContainer = ({ ...Props }) => <Video {...Props} />;

export default VideoContainer;
